import React from "react";
import { Link, useLocation } from "react-router-dom";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      {useLocation().pathname === "/" && <Link to="/about">About Us</Link>}
      <p>Copyright ⓒ {year}</p>
    </footer>
  );
}

export default Footer;
